import PropTypes from "prop-types"
import React from "react"

import ServicePageV2Desktop from "./ServicePageV2Desktop"
import ServicePageV2Mobile from "./ServicePageV2Mobile"

const ServicePageV2 = ({ practice, service, theme, viewMode = "", deviceType = "desktop" }) => {
  // If viewMode is explicitly set (from preview), use that to determine which component to show
  if (viewMode === "mobile") {
    return <ServicePageV2Mobile practice={practice} service={service} theme={theme} />
  }

  if (viewMode === "desktop") {
    return <ServicePageV2Desktop practice={practice} service={service} theme={theme} />
  }

  // Use server-side device detection for public pages
  if (deviceType === "mobile") {
    return <ServicePageV2Mobile practice={practice} service={service} theme={theme} />
  }

  // Default to desktop for desktop devices
  return <ServicePageV2Desktop practice={practice} service={service} theme={theme} />
}

ServicePageV2.propTypes = {
  practice: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    practitionerName: PropTypes.string,
    practitionerImage: PropTypes.string,
    user: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      title: PropTypes.string,
      profilePhotoUrl: PropTypes.string
    }),
    reviewsAverage: PropTypes.number,
    reviewsCount: PropTypes.number,
    location: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        city: PropTypes.string,
        state: PropTypes.string
      })
    ]),
    locations: PropTypes.arrayOf(PropTypes.object),
    pages: PropTypes.arrayOf(PropTypes.object),
    socialLinks: PropTypes.object
  }).isRequired,
  service: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    amountCents: PropTypes.number,
    timeLength: PropTypes.number,
    imageUrl: PropTypes.string,
    locations: PropTypes.arrayOf(PropTypes.object),
    variations: PropTypes.arrayOf(PropTypes.object),
    addOns: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        amountCents: PropTypes.number.isRequired
      })
    )
  }).isRequired,
  theme: PropTypes.object,
  viewMode: PropTypes.string,
  deviceType: PropTypes.string
}

export default ServicePageV2
